export default function PageJsonLd() {
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Тренинг по телефонным продажам',
    provider: {
      '@type': 'Person',
      name: 'Алексей Сивко',
      description: 'Бизнес-тренер с более чем 18-летним опытом в продажах и переговорах',
      url: 'https://sivko.by/',
    },
    description: 'Корпоративный тренинг по телефонным продажам для компаний. Обучение холодным звонкам, работе с возражениями, выявлению потребностей и увеличению конверсии. Практика на реальных звонках компании.',
    areaServed: ['Беларусь', 'Россия', 'Казахстан', 'Израиль'],
    serviceType: 'Корпоративное обучение телефонным продажам',
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      category: 'Корпоративный тренинг',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Что входит в тренинг по телефонным продажам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Тренинг включает диагностику текущего уровня команды, прослушивание реальных звонков, практическую отработку навыков на кейсах компании, работу с возражениями, обучение технике SPIN и активному слушанию, домашние задания и посттренинговое сопровождение с разбором новых записей разговоров.',
        },
      },
      {
        '@type': 'Question',
        name: 'Чем обучение отличается от обычного тренинга по холодным звонкам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Это не тренинг по скриптам, а системное обучение управлению телефонной продажей. Мы не учим зачитывать готовые фразы — мы развиваем навыки: как открыть разговор, удержать внимание, выявить настоящую потребность, работать с эмоциями клиента и завершить звонок конкретным следующим шагом. Плюс программа включает сопровождение внедрения, а не только однодневное мероприятие.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли обучить опытных менеджеров?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, опытные менеджеры часто получают наибольшую отдачу от обучения. Мы выявляем скрытые неэффективные привычки, накопившиеся за годы, усиливаем сильные стороны и помогаем выйти на качественно новый уровень конверсии. Программа адаптируется под уровень каждого участника — от новичков до руководителей.',
        },
      },
      {
        '@type': 'Question',
        name: 'Работаете ли вы с B2B?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, мы специализируемся на B2B-продажах. Обучаем выходить на ЛПР, проходить секретарей и ассистентов, формулировать ценность для бизнес-аудитории, проводить многоэтапные переговоры и назначать встречи с лицами, принимающими решения. Все кейсы строятся на реальных сценариях из вашей отрасли.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли анализировать реальные звонки?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, это основа нашей программы. Мы прослушиваем реальные записи звонков ваших менеджеров до обучения, анализируем их вместе с участниками и разбираем: что работает, что теряет клиента, как усилить каждый этап разговора. Это в десятки раз эффективнее абстрактных упражнений.',
        },
      },
      {
        '@type': 'Question',
        name: 'Проводится ли обучение онлайн?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, тренинг полностью доступен в онлайн-формате: живые сессии с отработкой звонков через видеосвязь, ролевые переговоры, детальный разбор реальных записей разговоров. Онлайн-формат полностью сохраняет практическую направленность и эффективность обучения.',
        },
      },
      {
        '@type': 'Question',
        name: 'Сколько длится программа?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Форматы варьируются: интенсивный тренинг — 1-2 полных дня, модульная программа — от 2 недель до 2 месяцев, комплексная программа с сопровождением — 3-6 месяцев. Точная продолжительность определяется после диагностики текущего уровня команды и поставленных бизнес-целей.',
        },
      },
      {
        '@type': 'Question',
        name: 'Что происходит после тренинга?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'После основного тренинга мы продолжаем работу: разбираем новые записи звонков, корректируем стратегию, поддерживаем участников в чате, помогаем внедрять регламенты и стандарты. Именно посттренинговое сопровождение обеспечивает закрепление навыков и устойчивый рост показателей.',
        },
      },
      {
        '@type': 'Question',
        name: 'Как быстро появляются результаты?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Первые изменения в качестве разговора видны уже после первого дня обучения. Измеримые бизнес-результаты — рост конверсии, увеличение назначенных встреч, сокращение цикла сделки — обычно проявляются через 2-4 недели при условии активного внедрения и сопровождения.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли провести обучение в Минске и других странах?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, мы проводим обучение в Минске, а также выезжаем в любую точку Беларуси, России, Казахстана и других стран СНГ. Онлайн-формат доступен для компаний из любой точки мира. География наших проектов включает десятки городов.',
        },
      },
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Главная',
        item: { '@id': 'https://business-training.by/', name: 'Главная' },
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Продажи и переговоры',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-prodazham', name: 'Продажи и переговоры' },
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'Тренинг по телефонным продажам',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-telefonnym-prodazham', name: 'Тренинг по телефонным продажам' },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
    </>
  );
}